import { Document2Icon, DowloadFIleIcon, SearchIcon } from "~/assets/icons";
import styles from "./DocumentTab.module.scss";
import classNames from "classnames/bind";
import { BaseTable } from "~/components/common";
import { useAppDispatch, useAppSelector } from "~/redux/hooks";
import { useEffect, useRef, useState } from "react";
import { crmActions } from "~/thunks/crm/crmSlice";
import { handleGetDocuments } from "~/thunks/crm/crmThunk";
import { notify } from "~/utils/helper";
import { IDocument } from "~/utils/interface/crm";
import { forEach } from "lodash";

const cx = classNames.bind(styles);

interface DocumentTabProps {
  onOpenUploadFileModal: () => void;
}

const headCells = [
  { id: "name", label: "Name", width: "25%" },
  { id: "description", label: "Description", width: "15%" },
  { id: "size", label: "Size", width: "10%" },
  { id: "uploadedDate", label: "Uploaded Date", width: "20%" },
  { id: "uploadedBy", label: "Uploaded By", width: "20%" },
  { id: "action", label: "Action", width: "10%" },
];

const DocumentTab = ({ onOpenUploadFileModal }: DocumentTabProps) => {
  const idClient = window.location.pathname.split("/").pop();
  const dispatch = useAppDispatch();
  const [textSearch, setTextSearch] = useState("");
  const searchTimeout = useRef<NodeJS.Timeout | null>(null);
  const { documents, needRefreshData } = useAppSelector((state) => state.crm);

  useEffect(() => {
    return () => {
      dispatch(crmActions.setCurrentPage(1));
    };
  }, [dispatch, idClient, needRefreshData]);

  useEffect(() => {
    if (needRefreshData || dispatch) {
      dispatch(
        handleGetDocuments({
          idClient: idClient,
          params: { textSearch: textSearch },
        })
      )
        .unwrap()
        .then(() => {
          dispatch(crmActions.changeNeedRefreshData(false));
        })
        .catch((error) => {
          notify("error", `Failed to fetch documents: ${error}`);
        });
    }
  }, [needRefreshData, dispatch, idClient, textSearch]);

  const handleDownload = (url: any, fileName: any) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAll = async () => {
    forEach(documents, (doc) => {
      handleDownload(doc.documentUrl, doc.name);
    });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setTextSearch(value);
    }, 1000);
  };

  return (
    <div className={cx("document-tab-container")}>
      <div className={cx("header")}>
        <div className={cx("search")}>
          <SearchIcon className={cx("search-icon")} />
          <input
            type="text"
            placeholder="Search jobs..."
            className={cx("search-input")}
            onChange={handleSearchChange}
          />
        </div>

        <button className={cx("file-button")} onClick={onOpenUploadFileModal}>
          <DowloadFIleIcon className={cx("file-icon")} />
          <p className={cx("file-text")}>Upload Files</p>
        </button>

        <button className={cx("file-button")} onClick={handleDownloadAll}>
          <DowloadFIleIcon className={cx("file-icon", "rotate-180")} />
          <p className={cx("file-text")}>Download All</p>
        </button>
      </div>

      <div className={cx("body")}>
        {/* <BaseTable
          data={documents}
          renderCell={(document: IDocument, index: number) => (
            <>
              <td className={cx("table-body-cell", "w-[25%]")}>
                <div className={cx("document-cell")}>
                  <Document2Icon className={cx("document-icon")} />
                  <div className={cx("document-info")}>
                    <h3 className={cx("document-name")}>{document.name}</h3>
                    <p className={cx("document-uploaded-by")}>
                      {document.uploadedBy}
                    </p>
                  </div>
                </div>
              </td>
              <td className={cx("table-body-cell", "w-[15%]")}>
                <p className={cx("document-text")}>{document.description}</p>
              </td>
              <td className={cx("table-body-cell", "w-[10%]")}>
                <p className={cx("document-text")}>{document.size}</p>
              </td>
              <td className={cx("table-body-cell", "w-[20%]")}>
                <p className={cx("document-text")}>
                  {document.uploadedDate
                    ? new Date(document.uploadedDate).toLocaleDateString(
                        "vi-VN",
                        {
                          timeZone: "Asia/Ho_Chi_Minh",
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                        }
                      )
                    : ""}
                </p>
              </td>
              <td className={cx("table-body-cell", "w-[20%]")}>
                <p className={cx("document-text")}>{document.uploadedBy}</p>
              </td>
              <td className={cx("table-body-cell", "w-[10%]")}>
                <div className={cx("action-buttons")}>
                  <button
                    className={cx("action-button")}
                    onClick={() =>
                      handleDownload(document.documentUrl, document.name)
                    }
                  >
                    Download
                  </button>
                  <button className={cx("action-button")}>Share</button>
                </div>
              </td>
            </>
          )}
          headCells={headCells}
          page={1}
          totalPages={1}
          onChangePage={() => {}}
          showPagination={false}
        /> */}
      </div>
    </div>
  );
};

export default DocumentTab;
